// Cartões de visita digitais — /cartao/:slug
// Conteúdo fixo em PT (artefacto pessoal entregue em mãos/QR). Fotos: foto: null = monograma;
// para substituir, colocar o ficheiro em /public/images/ e indicar o caminho (ex.: "/images/cartao-paula.jpg").
export const CARTAO_COMUM = {
    fundador: "Membro Fundador da Associação Fados à Mesa",
    email: "production@fadosamesa.ch",
    morada: "Gerliswilstrasse 46, 6020 Emmenbrücke, Suíça",
    moradaMaps: "https://www.google.com/maps/search/?api=1&query=Gerliswilstrasse+46%2C+6020+Emmenbr%C3%BCcke%2C+Su%C3%AD%C3%A7a",
    website: "fadosamesa.ch",
    websiteUrl: "https://fadosamesa.ch",
    instagram: "https://www.instagram.com/fadosamesa/",
    facebook: "https://www.facebook.com/profile.php?id=61594181040230",
    mostrarSociais: true, // false oculta a linha de redes sociais em todos os cartões
};

export const CARTOES = {
    "paula-angelino": {
        nome: "Paula Angelino",
        cargo: "Presidente e Diretora Executiva",
        telemovel: "+41 78 259 53 38",
        foto: null,
    },
    "cristina-moita": {
        nome: "Cristina Moita",
        cargo: "Vice-Presidente e Responsável de Cozinha",
        telemovel: "+41 76 433 14 46",
        foto: null,
    },
    "paulo-nunes": {
        nome: "Paulo Nunes",
        cargo: "Diretor Técnico",
        telemovel: "+41 78 444 19 80",
        foto: null,
    },
    "paula-silva": {
        nome: "Paula Silva",
        cargo: "Diretora de Logística e Staff",
        telemovel: "+41 79 901 97 10",
        foto: null,
    },
};
